<template>
    <div class="ah-page special-project-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>特定費用設定</h1>
                    </div>
                    <div class="actions">
                        <el-select v-model="year" size="" placeholder="年度" @change="handleYearChange" style="margin-right: 10px">
                            <el-option key="none" label="不限年份" :value="null" />
                            <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                        </el-select>
                        <el-button
                            v-if="!isQR()"
                            @click="
                                $router.push({
                                    name: 'special-disbursement-project-add'
                                })
                            "
                            type="highlight"
                            >新增特定費用項目</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <el-row :gutter="20">
                    <el-col :sm="10">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">總預算金額</div>
                                <div class="statis-num">
                                    <Money :v="amoutTotal.totalAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="7">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    已支出金額<ahTip>
                                        <PaymentStatusLabel :statusNum="2" />＋
                                        <PaymentStatusLabel :statusNum="3" />
                                        的請款總額
                                    </ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="amoutTotal.creditedAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="7">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">總預算餘額<ahTip>總預算金額 - 已支出金額</ahTip></div>
                                <div class="statis-num">
                                    <Money :v="amoutTotal.totalAmount - amoutTotal.creditedAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="ah-container" style="margin-top: 25px">
            <div class="ah-panel">
                <div class="panel-body">
                    <ahDataTable
                        tableKey="special-project-data-table"
                        :columns="columns"
                        :data="datas"
                        :showRefreshButton="true"
                        :indexStart="PageSize * (PageNum - 1) + 1"
                        v-loading="status == 'loading'"
                        @row-click="handleDataRowClick"
                        @refresh="updateData"
                    >
                        <template v-slot:poo="scope">
                            <div class="idx">{{ scope.row.poo }}</div>
                        </template>
                        <template v-slot:amt="scope">
                            <Money :v="scope.row.amt" />
                        </template>
                    </ahDataTable>
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="PageNum"
                        :small="isMobile()"
                        @current-change="handlePaginationChange"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <DetailDialog ref="detailDialog" :visible="detailDialogVisible" :sno="detailDialogSno" @close="handleDetailDialogClose" />
    </div>
</template>
<script>
import ahDataTable from '@/components/ui/ahDataTable.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import DetailDialog from './DetailDialog.vue';

export default {
    name: 'SpecialProject',
    components: { PaymentStatusLabel, DetailDialog, ahDataTable },
    data() {
        return {
            detailDialogVisible: false,
            detailDialogSno: null,
            showEditDialog: false,
            PageNum: 1,
            PageSize: 25,
            totalDataCount: 0,
            status: '',
            datas: [],
            year: null,
            errorMsg: '',
            amoutTotal: {},
            selectedItem: {},
            yearList: [],
            columns: {
                index: {
                    label: '#',
                },
                poo: {
                    label: '系統編號',
                    width: 120,
                },
                nam: {
                    label: '特定費用項目名稱',
                    disableHide: true,
                },
                stF_NAM: {
                    label: '建立人',
                    width: 150,
                },
                amt: {
                    label: '總預算',
                    width: 150,
                    align: 'right',
                },
                cny: {
                    label: '幣別',
                    width: 80,
                },
            },
        };
    },
    created() {},
    mounted() {
        this.fetchYearList(() => {
            if (this.$route.query.year) {
                this.year = this.$route.query.year;
            }
            this.updateData();
        });
    },
    methods: {
        // 按下表格一行
        handleDataRowClick(data) {
            // 開啟詳細資料卡
            this.detailDialogVisible = true;
            this.detailDialogSno = data.sno;
        },
        handleYearChange() {
            this.$router.replace({
                name: 'special-disbursement-project',
                query: { year: this.year },
            });
            this.updateData();
        },
        handlePaginationChange() {
            this.updateData();
        },
        // 關閉詳細資料後
        handleDetailDialogClose(refresh) {
            this.detailDialogVisible = false;
            this.detailDialogSno = null;
            if (refresh) {
                this.updateData();
            }
        },
        // 取得年份列表
        fetchYearList(callback) {
            this.$api({
                url: 'SpecialProjectManagementPage/GetYears',
                method: 'GET',
            }).then((resp) => {
                this.status = 'success';
                if (resp.data.items && resp.data.items.length > 0) {
                    this.yearList = resp.data.items.reverse();
                } else {
                    this.yearList = [new Date().getFullYear()];
                }
                callback();
            });
        },
        // 更新客戶（顯示頁面時觸發）
        updateData() {
            this.status = 'loading';
            this.$api({
                url: 'SpecialProjectManagementPage/GetSpecailProjectList',
                params: {
                    PageNum: this.PageNum,
                    PageSize: this.PageSize,
                    Year: this.year,
                },
                method: 'GET',
            }).then((resp) => {
                console.log(resp);
                this.status = 'success';
                this.datas = resp.data.items;
                this.amoutTotal = resp.data.amoutTotal;
                this.totalDataCount = resp.data.totalNum;
            });
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";

.special-project-page {
    .overbudget {
        color: red;
    }
}
</style>
